import React, { useState } from "react";
import TenantRentPaymentFormInterface from "../../../Interfaces/TenantRentPaymentForm.model";

interface TenantRentPaymentFormProps {
  initialFormValues?: TenantRentPaymentFormInterface; // Optional prop
  postTenantPaidRentHistory: (rentPaymentDetails: any) => void; // Callback for parent to handle updates
}

const TenantRentPaymentForm: React.FC<TenantRentPaymentFormProps> = ({
  initialFormValues,
  postTenantPaidRentHistory,
}) => {
  const [tenantRentPaymentForm, setTenantRentPayment] =
    useState<TenantRentPaymentFormInterface>(
      initialFormValues || {
        clientId: 0,
        propertyId: 0,
        Id: 0,
        amountPaid: 0,
        paymentDate: "",
        partialPayment: false,
        amountDue: 0,
        monthPaid: "",
        isOnTime: true,
        notes: "",
      }
    );

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;
    const isCheckbox = type === "checkbox";

    setTenantRentPayment((prev: any) => ({
      ...prev,
      [name]: isCheckbox ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const checkStatusOfPartialPayment = () => {
    const actualRent = tenantRentPaymentForm.actualRent ?? 0;
    const amountPaid = tenantRentPaymentForm.amountPaid ?? 0;

    if (amountPaid >= actualRent) {
      tenantRentPaymentForm.partialPayment = false;
      tenantRentPaymentForm.amountDue = 0; // No amount due if fully paid or overpaid
      return true;
    } else {
      tenantRentPaymentForm.partialPayment = true;
      tenantRentPaymentForm.amountDue = actualRent - amountPaid;
      return false;
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Form Data Submitted:", tenantRentPaymentForm);
    // You can send `tenantRentPaymentForm` to your API here
    postTenantPaidRentHistory(tenantRentPaymentForm);
  };

  return (
    <form onSubmit={handleSubmit} className="tenant-rent-payment-form">
      <label>
        Amount Paid:
        <input
          type="number"
          step="0.01"
          name="amountPaid"
          value={tenantRentPaymentForm.amountPaid}
          onChange={handleChange}
          required
        />
      </label>

      <label>
        Payment Date:{" "}
        <input
          type="date"
          name="paymentDate"
          value={tenantRentPaymentForm.paymentDate}
          onChange={handleChange}
          required
        />
      </label>

      <label>
        Partial Payment:
        <input
          type="checkbox"
          disabled={checkStatusOfPartialPayment()}
          name="partialPayment"
          checked={tenantRentPaymentForm.partialPayment}
          onChange={handleChange}
        />
      </label>

      <label>
        Amount Due:
        <input
          type="number"
          step="0.01"
          name="amountDue"
          value={tenantRentPaymentForm.amountDue}
          onChange={handleChange}
          required
        />
      </label>

      <label>
        Month Paid:
        <select
          name="monthPaid"
          value={tenantRentPaymentForm.monthPaid}
          onChange={handleChange}
          required
        >
          <option value="">Select a month</option>
          {[
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ].map((month) => (
            <option key={month} value={month}>
              {month}
            </option>
          ))}
        </select>
      </label>

      <label>
        Paid On Time:
        <input
          type="checkbox"
          name="isOnTime"
          checked={tenantRentPaymentForm.isOnTime}
          onChange={handleChange}
        />
      </label>

      <label>
        Notes:
        <textarea
          name="notes"
          value={tenantRentPaymentForm.notes}
          onChange={handleChange}
          placeholder="Optional notes"
        />
      </label>

      <button className="submit-button" type="submit">
        Submit Payment
      </button>
    </form>
  );
};

export default TenantRentPaymentForm;
